import React from 'react';
import {Stack} from '@mui/system';
import {Body, Button, Headline} from '@lightricks/react-design-system';
import {FEATURE_ID} from '@/views/content-studio/constants';
import onboardingWizardStore, {
  onboardingWizardActions,
} from '../../onboardingWizardStore';
import FeatureButton from './FeatureButton';
import getFeatureInfo from './getFeatureInfo';

function FeatureSelectionMenu({onNext}: {onNext: () => void}) {
  const {selectedFeature} = onboardingWizardStore();
  return (
    <Stack alignItems="center" justifyContent="center" width="100%">
      <Stack gap="12px" width="40vw" height="100%">
        <Headline size="lg" marginBottom="-4px">
          What do you want to do first?
        </Headline>
        <Body size="lg" marginBottom="24px">
          Choose a tool to kick off your first project
        </Body>
        {Object.values(FEATURE_ID).map((featureId) => (
          <FeatureButton
            key={featureId}
            featureInfo={getFeatureInfo(featureId)}
            onClick={() => {
              onboardingWizardActions.setSelectedFeature(featureId);
            }}
            isSelected={selectedFeature === featureId}
            onMouseEnter={() => {
              onboardingWizardActions.setHoveredFeature(featureId);
            }}
            onMouseLeave={() => {
              onboardingWizardActions.setHoveredFeature(null);
            }}
          />
        ))}
        <Button
          sx={{marginTop: '44px'}}
          appearance="neutral"
          mode="filled"
          size="large"
          onClick={onNext}
          disabled={selectedFeature === null}
        >
          Get started
        </Button>
      </Stack>
    </Stack>
  );
}

export default FeatureSelectionMenu;
